export const layers = {
  examinationPageHeader: 10,
  appHeader: 20,
  popper: 50,
  cookiebar: 100,
  snackbar: 200,
  modal: 1000,
} as const;
